module.exports = __webpack_public_path__ + "img/9788936486013.6c8d9f5a.jpg";